module.exports = __webpack_public_path__ + "static/media/Cottonv1.0.dccd4150.PNG";